<template>
  <Thankyou />
</template>

<script>
import Thankyou from '@/components/order/Thankyou'

export default {
  name: 'ThankyouPage',
  components: { Thankyou },
  metaInfo() {
    return {
      title: this.$t('meta.other.titleTmpl', {
        h1: this.$t('thankyou'),
      }),
      meta: [
        {
          name: 'robots',
          content: 'noindex, follow',
        },
        {
          name: 'description',
          content: this.$t('meta.other.descriptionTmpl', {
            h1: this.$t('thankyou'),
          }),
        },
      ],
    }
  },
  mounted() {
    this.$h.gtmDataLayerPush({
      ecomm_pagetype: 'other',
    })
  },
}
</script>
